"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridCoreSkeleton = void 0;
const react_1 = __importDefault(require("react"));
const GridCoreSkeleton_styles_1 = require("./GridCoreSkeleton.styles");
exports.GridCoreSkeleton = react_1.default.memo(({ width }) => {
    return (react_1.default.createElement(GridCoreSkeleton_styles_1.StyledGridCoreSkeleton, { style: {
            width: width !== null && width !== void 0 ? width : `${Math.random() * 35 + 50}%`
        } }));
});
exports.GridCoreSkeleton.displayName = 'GridCoreSkeleton';
//# sourceMappingURL=GridCoreSkeleton.js.map